export const getAddress = (address: string | undefined): any => {
  const addressSplit = address?.split(',')

  const addr = {
    streetAddress: '',
    addressLocality: '',
    addressRegion: '',
    postalCode: '',
  }

  if (addressSplit && addressSplit.length === 3) {
    addr.streetAddress = addressSplit[0]
    addr.addressLocality = addressSplit[1]
    addr.addressRegion = addressSplit[2].trim().split(' ')[0]
    addr.postalCode = addressSplit[2].trim().split(' ')[1]
  } else if (addressSplit && addressSplit.length === 5) {
    addr.streetAddress = addressSplit[0] + addressSplit[1] + addressSplit[2]
    addr.addressLocality = addressSplit[3]
    addr.addressRegion = addressSplit[4].split(' ')[0]
    addr.postalCode = addressSplit[4].split(' ')[1]
  }
  return addr
}

export default getAddress
